module.exports = __webpack_public_path__ + "img/ic_tel.5cb44bbc.svg";